import { defineComponent, getCurrentInstance, h } from 'vue';
import { Form, Field, defineRule } from 'vee-validate';
import { required, email } from '@vee-validate/rules';
import IBAN from 'iban'

defineRule("required", value => required(value) || "Das Feld must gefüllt sein");

defineRule("email", value => email(value) || "Bitte tragen Sie eine gültige E-Mail-Adresse ein");

defineRule('postalcode', value => {
  if (value == null || value === '') {
    return true;
  }
  if (Number.isInteger(value)) {
    return (value > 0 && value < 10000) || 'Bitte tragen Sie eine gültige PLZ ein.';
  }
  return value.match(/^\d{5}$/) != null || 'Bitte tragen Sie eine gültige PLZ ein.';
});

defineRule('iban', value => {
  if (value == null || value === '') {
    return true;
  }
  return IBAN.isValid(value) || 'Bitte tragen Sie eine gültige IBAN ein.';
});

const ValidationProvider = defineComponent({
  name: 'ValidationProvider',
  props: {
    name: {
      type: String,
      default: undefined,
    },
    rules: {
      type: [String, Object, Function],
      default: undefined,
    },
  },
  setup(props, { slots }) {
    const instance = getCurrentInstance();
    const fallbackName = `field-${instance?.uid ?? Math.random().toString(36).slice(2)}`;
    const resolvedName = props.name || fallbackName;
    const resolvedRules = props.rules === true ? undefined : props.rules;
    return () =>
      h(
        Field,
        {
          name: resolvedName,
          rules: resolvedRules,
        },
        slots
      );
  },
});

const ValidationObserver = defineComponent({
  name: 'ValidationObserver',
  setup(_, { slots }) {
    return () => h(Form, null, slots);
  },
});

export default function registerVeeValidate(app) {
  // Register compat components globally
  app.component('ValidationProvider', ValidationProvider);
  app.component('ValidationObserver', ValidationObserver);
}
